import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import { FORM_CLASSIFIERS_GRID_OPERATOR_EDIT } from '../../constants/formKeys';
import {
  getClassifiersGridOperatorChange,
  getClassifiersGridOperatorItem,
  getClassifiersGridOperatorItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { gridOperator } from '../../constants/parameters';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

export class ParameterGridOperatorEdit extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    fetchClassifierGridOperator: PropTypes.func.isRequired,
    changeClassifierGridOperator: PropTypes.func.isRequired,
    fetchClassifierGridOperatorList: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    operatorCode: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  };

  componentDidMount = () => {
    const { operatorCode } = this.props;

    if (operatorCode) {
      this.props.fetchClassifierGridOperator(operatorCode);
    }
  };

  onSubmit = async (values) => {
    const {
      t,
      changeClassifierGridOperator,
      fetchClassifierGridOperatorList,
      onComplete,
    } = this.props;

    const result = await changeClassifierGridOperator(values);

    if (!result.error) {
      notification.info({
        message: t('completeTitle'),
        description: t('completeBody'),
      });

      onComplete();
    }
    await fetchClassifierGridOperatorList();
    await classifiersStore.update();
  };

  render() {
    const { t, isLoading, operatorCode, onCancel, initialValues } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_CLASSIFIERS_GRID_OPERATOR_EDIT} />
              <Row gutter={32}>
                <Col span={24}>
                  <Field
                    name={gridOperator.CODE}
                    label={t('fieldCode')}
                    component={TextField}
                    disabled={!!operatorCode}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={gridOperator.NAME}
                    label={t('fieldGridOperatorName')}
                    component={TextField}
                    required
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={gridOperator.EMAIL}
                    label={t('fieldGridOperatorEmail')}
                    component={TextField}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={gridOperator.DATE_CRON}
                    label={t('fieldGridOperatorDate')}
                    component={TextField}
                    required
                  />
                </Col>
              </Row>
              <FormActions>
                <Button onClick={onCancel}>{t('buttonCancel')}</Button>
                <Button htmlType="submit" type="primary">
                  {t('buttonSave')}
                </Button>
              </FormActions>
            </form>
          )}
        />
      </Spin>
    );
  }
}

const getIsLoading = getLoadingSelector(
  getClassifiersGridOperatorChange,
  getClassifiersGridOperatorItem
);

const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.operatorCode
    ? getClassifiersGridOperatorItemData(state)?.toJS()
    : {},
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  fetchClassifierGridOperator: actions.fetchClassifierGridOperator,
  changeClassifierGridOperator: actions.changeClassifierGridOperator,
  fetchClassifierGridOperatorList: actions.fetchClassifierGridOperatorList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParameterGridOperatorEdit);
